import { DOMAIN } from '../../../../../var_env.'
import { RequestResponsePattern } from '../../../../../types/Request'
import { postApi } from '../../../../../utils/requestApi'

type AddBody = {
  idsPessoa: number[],
  titulo: string
}

export default async function addAnaliseAmostraTerceira(idsPessoa: number[], titulo: string): Promise<void> {
  const endpoint = `${DOMAIN}/AnaliseAmostraTerceira`
  const data: AddBody = { idsPessoa, titulo }

  const response: RequestResponsePattern<any> = await postApi({ endpoint, data })

  if (response) {
    if (!response.flagErro) return
    throw new Error(response.listaMensagens[0])
  }

  throw new Error('Erro na requisição')
}

